import { useState } from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import { Button, message } from 'antd';
import { getDmcaInfoApi } from '@/lib/service/erasa';
import SubmitModal from './SubmitModal';
import { useUserProvider } from '@/context/UserProvider';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { postAddManualClewApi } from '@/lib/service/erasa';

const Index: React.FC<any> = () => {
  const { isLogin, onOpenLoginModal, userUse, UpDateUserSub } = useUserProvider();
  const router = useRouter();
  const [active, setActive] = useState(0); // 0 ,1
  const [link, setLink] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorIndex, setErrorIndex] = useState<number>(-1);
  const [sitesList, setSitesList] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [linkList, setLinkList] = useState<any[]>([]);
  const handleGenerateTemplate = () => {
    const urlList = link.split('\n').filter((item) => item != '');
    const pattern1 = /^https:\/\/.+/;
    const pattern2 = /^http:\/\/.+/;
    setLinkList(urlList);
    if (link == '') {
      setErrorIndex(1);
      return;
    }
    for (let i = 0; i < urlList.length; i++) {
      if (!pattern1.test(urlList[i]) && !pattern2.test(urlList[i])) {
        setErrorIndex(i);
        return;
      }
    }
    urlList.forEach((item) => item.trim());
    if (active == 0) {
      setLoading(true);
      getDmcaInfoApi({
        urls: urlList,
      }).then((res: any) => {
        if (res.code == 0) {
          setLoading(false);
          setSitesList(res.data.sites);
          setIsModalOpen(true);
          setLinkList([]);
        } else {
          setLoading(false);
          setLinkList([]);
          message.warning(res.message);
        }
      });
    } else {
      if (!isLogin) {
        onOpenLoginModal(true);
      } else {
        if (userUse?.remain_request_num >= urlList.length || userUse?.remain_request_num == -1) {
          setLoading(true);
          postAddManualClewApi({
            links: urlList,
          }).then((res: any) => {
            UpDateUserSub();
            setLoading(false);
            if (res.code == 0) {
              message.success('Submit successfully');
              router.push('/dashboard');
            } else {
              message.warning(res.message);
            }
          });
        } else {
          message.warning('Please upgrade to use this feature');
          router.push('/setting');
        }
      }
    }
  };
  useEffect(() => {
    setLink('');
    setErrorIndex(-1);
  }, [active]);

  const getErrorText = () => {
    if (linkList.length == 0) {
      if (errorIndex == -1) {
        return '';
      } else {
        return 'Please enter at least one URL';
      }
    } else {
      if (errorIndex != -1) {
        return ` Please enter valid URLs. Invalid entries found:(${linkList[errorIndex]})`;
      }
    }
  };
  return (
    <div className={styles.container}>
      <div className={styles.main}>
        <ul className={styles.tab}>
          <div className={styles.activeBlock} style={{ left: active === 0 ? '0' : '50%' }}></div>
          <li onClick={() => setActive(0)}>
            <Image
              src="https://res-front.pumpsoul.com/prod-erasa/image/dmca-takedown/step-1.svg"
              alt="icon"
              width={20}
              height={20}
            />
            <span>Manual DIY</span>
          </li>
          <li onClick={() => setActive(1)}>
            <Image
              src="https://res-front.pumpsoul.com/prod-erasa/image/dmca-takedown/step-2.svg"
              alt="icon"
              width={20}
              height={20}
            />
            <span>Automatic DMCA</span>
            <div className={styles.vip}>👑 Subscribers Only</div>
          </li>
        </ul>
        {active == 0 ? (
          <div className={styles.step1} style={{ borderTopLeftRadius: active == 0 ? '0px' : '15px' }}>
            <div className={styles.label}>Infringing content link</div>
            <div className={styles.ipt}>
              <textarea
                onFocus={() => {
                  setErrorIndex(-1);
                }}
                style={{
                  borderColor: errorIndex != -1 ? '#2E9CFF' : '#d9d9d9',
                  backgroundColor: '#ffffff',
                  color: '#000000',
                }}
                value={link}
                onChange={(e) => setLink(e.target.value)}
                placeholder="Enter links to infringing content (one per line)"
              ></textarea>
              <div className={styles.error}>
                {/* {errorIndex != -1 && `第${errorIndex + 1}行格`} */}
                {getErrorText()}
              </div>
            </div>
            <div className={styles.btn}>
              <Button onClick={handleGenerateTemplate} loading={loading}>
                <img src="https://res-front.pumpsoul.com/prod-erasa/image/dmca-takedown/to-right.svg" alt="btn" />
                <span>Generate Template</span>
              </Button>
            </div>
          </div>
        ) : (
          <div className={styles.step1} style={{ borderTopRightRadius: active == 1 ? '0px' : '15px' }}>
            <div className={styles.label}>Links to be removed（one per line）</div>
            <div className={styles.ipt}>
              <textarea
                onFocus={() => {
                  setErrorIndex(-1);
                }}
                style={{
                  borderColor: errorIndex != -1 ? '#2E9CFF' : '#d9d9d9',
                  backgroundColor: '#ffffff',
                  color: '#000000',
                }}
                value={link}
                onChange={(e) => setLink(e.target.value)}
                placeholder="Enter links to infringing content (one per line)"
              ></textarea>
              <div className={styles.error}>{getErrorText()}</div>
            </div>
            <div className={styles.btn} onClick={handleGenerateTemplate}>
              <Button loading={loading}>
                <img src="https://res-front.pumpsoul.com/prod-erasa/image/dmca-takedown/to-right.svg" alt="btn" />
                <span>Submit DMCA Request</span>
              </Button>
            </div>
          </div>
        )}
        <ul className={styles.tags}>
          <li className={styles.active}>🕶 Fully anonymous</li>
          <li>⚡Instant action</li>
          <li>😄 Zero Hassle</li>
        </ul>
      </div>
      <SubmitModal isModalOpen={isModalOpen} handleCancel={() => setIsModalOpen(false)} sitesList={sitesList} />
    </div>
  );
};

export default Index;
